;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();export function getEorHref(path: string): string {
  return `${process.env.NEXT_PUBLIC_FE_URL_EOR!.replace(/\/+$/, '')}${path}`;
}

export function getEorSupportRequestsHref(options?: { open?: boolean; from?: string }): string {
  const params = new URLSearchParams();
  if (options?.open) params.set('request', 'open');
  if (options?.from) params.set('from', options.from);
  const query = params.toString();

  return getEorHref(query ? `/support/requests?${query}` : '/support/requests');
}
